// extracted by mini-css-extract-plugin
export var phone = "_4f-0";
export var phoneDragging = "_4f-1";